module.exports = __webpack_public_path__ + "img/bgtop.65931d15.jpg";